import axios from 'axios';
import qs from 'qs';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import {
  MUSIC_SEARCH,
  SEARCH_RESULTS,
  CURRENT_TRACK,
  ADVANCED_TRACK,
  SEARCH_RESULTS_ADVANCED,
  SEARCH_RESULTS_ADVANCED_START,
  AUTH_INPUT,
  SIGNUP_USERNAME_PASS,
  LOGIN_USERNAME_PASS,
  AUTH_LOGOUT,
  FACEBOOOK_AUTH,
  USER_DATA_FROM_FIRESTORE,
  FIREBASE_LOGIN,
  PASSWORD_RESET_EMAIL_SENT,
  CHANGE_LOGIN_EMAIL_SENT,
  UPDATE_USER_EMAIL,
  FILTER_OPTIONS,
  SET_PLAYING_TRACK,
  UPDATE_USERNAME,
  UPDATE_AUDIO_STATE,
  RESET_SEARCH,
  CLEAR_ADVANCED_TRACK_DATA,
  PERFORMING_BASIC_SEARCH,
  HOME_SEARCH_RESULT,
  FOOTER_IS_PAUSED,
  RESET_AUTH_FIELDS,
  MODAL_IS_OPEN,
  SEARCH_PERFORMED,
  SHOW_ADVANCED_DATA
} from '../constants/action-types';

let BASE = '/api';

if (process.env.NODE_ENV === 'development') {
  BASE = 'https://us-central1-cue-by-coolhand.cloudfunctions.net/';
}

export const _doRecentSearch = () => async (dispatch, getState) => {
  dispatch({
    type: HOME_SEARCH_RESULT,
    success: null,
    payload: null,
    searching: true,
  });
  try {
    const res = await axios.get(`${BASE}/home`, {
      headers: {
        'content-type': 'application/json'
      },
    });
    return dispatch({
      type: HOME_SEARCH_RESULT,
      success: true,
      payload: res.data.data,
      searching: false,
    });
  } catch (err) {
    return dispatch({
      type: HOME_SEARCH_RESULT,
      success: false,
      error: err,
      searching: false,
    });
  }
};

export const updateUserName = () => async (dispatch, getState) => {
  const {
    userName
  } = getState().auth;
  const firestore = firebase.firestore();
  const settings = {
    timestampsInSnapshots: true
  };
  firestore.settings(settings);
  try {
    if (firebase.auth().currentUser) {
      let uid;
      if (getState().auth.userInfo.uid) {
        uid = getState().auth.userInfo.uid;
      }
      if (!uid) {
        uid = getState().auth.userInfo.user.uid;
      }
      const docRef = firestore.doc(`profile/${uid}`);
      await docRef.set({
        userName,
      }, {
        merge: true
      });
      return dispatch({
        type: UPDATE_USERNAME,
        success: true,
        error: null,
      });
    }
  } catch (err) {
    return dispatch({
      type: UPDATE_USERNAME,
      success: false,
      error: err,
    });
  }
};

const saveSearchTerm = (searchTerm, uid) => {
  console.debug('Redux Actions->saveSearchTerm: saving search term for this user: ', uid);
  const firestore = firebase.firestore();
  const settings = {
    timestampsInSnapshots: true
  };
  firestore.settings(settings);
  if (typeof searchTerm !== 'string') {
    return null;
  }
  if (firebase.auth().currentUser) {
    const docRef = firestore.doc(`profile/${uid}`);

    return docRef.update({
      searches: firebase.firestore.FieldValue.arrayUnion(searchTerm),
    });
  }
  return console.debug('Redux Actions->savSearchTerm: no current user');
};

const _doMusicSearchApi = async body =>
  axios.post(`${BASE}/search`, JSON.stringify(body), {
    headers: {
      'content-type': 'application/json'
    },
  });

export const doMusicSearch = (s) => async (dispatch, getState) => {
  dispatch({
    type: PERFORMING_BASIC_SEARCH,
    payload: true,
  });

  const {
    search,
    filterOptions
  } = getState().music;
  if (search === '') {
    dispatch({
      type: SEARCH_RESULTS,
      payload: {},
      success: true,
      error: 'You need to enter something in the search box',
    });
    throw new Error('You need to enter something in the search box');
  }
  try {
    const body = {
      s: search,
      type: filterOptions,
    };
    const response = await _doMusicSearchApi(body);
    if (response.data.success === true) {
      console.debug('Redux Actions->doMusicSearch', response.data.data);
      dispatch({
        type: SEARCH_RESULTS,
        payload: response.data.data,
        success: true,
        error: null,
      });
      if (firebase.auth().currentUser) {
        let uid;
        if (getState().auth.userInfo.uid) {
          uid = getState().auth.userInfo.uid;
        }
        if (!uid) {
          uid = getState().auth.userInfo.user.uid;
        }
        const saveTermResults = await saveSearchTerm(search, uid);
        console.debug('Redux Actions->doMusicSearch', saveTermResults);
      }
    } else {
      dispatch({
        type: SEARCH_RESULTS,
        payload: response.data.data,
        success: true,
        error: response.data.error,
      });
    }
  } catch (e) {
    console.error('Redux Actions->doMusicSearch', e);
    dispatch({
      type: SEARCH_RESULTS,
      payload: null,
      success: false,
      error: e,
    });
  }
};

export const resetSearchResults = () => ({
  type: SEARCH_RESULTS,
  payload: null,
  success: null,
  error: null,
});

export const doAdvancedMusicSearch = () => async (dispatch, getState) => {
  const parsed = qs.parse(window.location.search, {
    ignoreQueryPrefix: true
  });
  let requestbody;
  const {
    id
  } = parsed;
  const {
    currentTrackBasicData,
    success
  } = getState().music;
  console.debug("ID is: ", id);
  if (!id) {
    console.error(`You didn't provide an ID`);
    return;
  }
  if (!success) {
    requestbody = {
      data: {
        id
      }
    };
  } else {
    requestbody = {
      search: {
        s: currentTrackBasicData.title,
        type: 'track',
      },
      data: currentTrackBasicData,
    };
  }
  try {
    dispatch({
      type: SEARCH_RESULTS_ADVANCED_START,
    });
    const response = await axios.post(`${BASE}/song`, JSON.stringify(requestbody), {
      headers: {
        'content-type': 'application/json'
      },
    });
    console.debug('Redux Actions->doAdvancedMusicSearch: ADAVCNED RESPONSE', response);
    if (response.data.success === true) {
      dispatch({
        type: SEARCH_RESULTS_ADVANCED,
        payload: response.data.data,
        success: true,
        error: null,
      });
    } else {
      console.debug('Redux Actions->doAdvancedMusicSearch: RESPONSE DATA', response)
      throw new Error('The the request failed');
    }
  } catch (e) {
    console.debug('Redux Actions->doAdvancedMusicSearch: ADVANCED SEARCH ERROR', e);
    dispatch({
      type: SEARCH_RESULTS_ADVANCED,
      payload: null,
      success: false,
      error: e,
    });
  }
};

export const searchInput = e => ({
  type: MUSIC_SEARCH,
  payload: e.target.value
});
export const searchInputWholeWord = v => ({
  type: MUSIC_SEARCH,
  payload: v
});

export const filterOptionsAction = e => ({
  type: FILTER_OPTIONS,
  payload: e.target.value
});

export const setCurrentTrack = t => ({
  type: CURRENT_TRACK,
  payload: t
});

export const authInput = e => ({
  type: AUTH_INPUT,
  payload: e
});

export const authLogout = () => async (dispatch, getState) => {
  try {
    const response = firebase.auth().signOut();
    dispatch({
      type: AUTH_LOGOUT,
      payload: response,
    });
  } catch (err) {
    console.debug('Redux Actions->authLogout', err);
    dispatch({
      type: AUTH_LOGOUT,
      payload: err.message,
      error: true,
    });
  }
};

export const doCreateUserCollection = async ({
  email,
  userName,
  signupResponse
}) => {
  console.debug(signupResponse);
  console.debug(firebase.auth().currentUser);
  const firestore = firebase.firestore();
  const settings = {
    timestampsInSnapshots: true
  };
  firestore.settings(settings);
  const docRef = firestore.doc(`profile/${signupResponse.user.uid}`);
  if (firebase.auth().currentUser) {
    try {
      const createCollectionResponse = await docRef.set({
        userName,
        email,
        favorites: [],
        searches: [],
      }, {
        merge: true
      });

      console.debug('Redux Actions->doCreateUserCollection', createCollectionResponse);
      return createCollectionResponse;
    } catch (err) {
      console.debug('Redux Actions->doCreateUserCollection', err);
      return err;
    }
  } else {
    console.debug('Redux Actions->doCreateUserCollection: no current user');
  }
};

export const getUserProfile = async uid => {
  const firestore = firebase.firestore();
  const settings = {
    timestampsInSnapshots: true
  };
  firestore.settings(settings);
  const docRef = firestore.doc(`profile/${uid}`);
  const doc = await docRef.get();
  if (doc.exists) {
    console.debug('Redux Actions->getUserProfile: user profile data exists');
    console.debug(doc.data());
    return doc.data();
  }
  console.debug('Redux Actions->getUserProfile: no user profile data in firestore =(');
  console.debug(doc);
  return false;
};

export const subscribeToUserProfile = () => async (dispatch, getState) => {
  dispatch({
    type: USER_DATA_FROM_FIRESTORE,
    success: true,
  });
  const firestore = firebase.firestore();
  const settings = {
    timestampsInSnapshots: true
  };
  firestore.settings(settings);
  const docRef = firestore.doc(`profile/${firebase.auth().currentUser.uid}`);
  console.debug(`Redux Actions->subscribeToUserProfile: profile/${firebase.auth().currentUser.uid}`);
  docRef.onSnapshot(
    doc => {
      console.debug(doc);
      dispatch({
        type: USER_DATA_FROM_FIRESTORE,
        payload: doc.data(),
        success: true,
        error: null,
      });
    },
    err => {
      console.debug(err);
      dispatch({
        type: USER_DATA_FROM_FIRESTORE,
        payload: null,
        success: false,
        error: err,
      });
    }
  );
};

export const SignupUserNamePass = () => async (dispatch, getState) => {
  const {
    email,
    userName,
    password
  } = getState().auth;

  if (!email || !password) {
    dispatch({
      type: SIGNUP_USERNAME_PASS,
      payload: null,
      success: false,
      error: 'you need to enter a username and password',
    });
  } else {
    try {
      const signupResponse = await firebase.auth().createUserWithEmailAndPassword(email, password);
      await doCreateUserCollection({
        email,
        userName,
        signupResponse
      });
      await firebase.auth().currentUser.sendEmailVerification();

      dispatch({
        type: SIGNUP_USERNAME_PASS,
        payload: signupResponse,
        success: true,
        error: null,
        isLoggedIn: true,
      });

      modalOpen(false)
    } catch (err) {
      dispatch({
        type: SIGNUP_USERNAME_PASS,
        payload: null,
        success: false,
        error: err.message,
      });
    }
  }
};

export const LoginUserNamePass = () => async (dispatch, getState) => {
  const {
    email,
    password
  } = getState().auth;
  if (!email || !password) {
    dispatch({
      type: LOGIN_USERNAME_PASS,
      payload: null,
      success: false,
      error: 'you need to enter a username and password',
    });
  } else {
    try {
      Promise.resolve(firebase.auth().signInWithEmailAndPassword(email, password))
        .then(loginResponse => {
          dispatch({
            type: LOGIN_USERNAME_PASS,
            payload: loginResponse,
            success: true,
            error: null,
            isLoggedIn: true,
          });
        })
    } catch (err) {
      dispatch({
        type: LOGIN_USERNAME_PASS,
        payload: null,
        success: false,
        error: err.message,
      });
    }
  }
};

export const doFacebookLogin = () => async (dispatch, getState) => {
  const provider = new firebase.auth.FacebookAuthProvider();
  provider.addScope('email');
  try {
    const signupResponse = await firebase.auth().signInWithPopup(provider);

    const {
      email,
      displayName,
      uid
    } = firebase.auth().currentUser;
    const userName = displayName;
    const profileData = await getUserProfile(uid);
    if (!profileData) {
      await doCreateUserCollection({
        email,
        userName,
        signupResponse
      });
    }
    dispatch({
      type: FACEBOOOK_AUTH,
      payload: signupResponse,
      success: true,
      error: null,
      isLoggedIn: true,
    });
  } catch (err) {
    dispatch({
      type: FACEBOOOK_AUTH,
      payload: null,
      success: false,
      error: err.message,
    });
  }
};

export const fetchUser = user => ({
  type: FIREBASE_LOGIN,
  payload: user,
  isLoggedIn: true,
  success: true,
  error: null,
});

export const resetSearch = () => ({
  type: RESET_SEARCH
});

export const updateUsername = () => async (dispatch, getState) => {
  const firestore = firebase.firestore();
  const settings = {
    timestampsInSnapshots: true
  };
  firestore.settings(settings);

  if (firebase.auth().currentUser) {
    const docRef = firestore.doc(`profile/${getState().auth.userInfo.user.uid}`);
    try {
      const Response = await docRef.set({
        userName: getState().auth.userName,
      }, {
        merge: true
      });

      return console.debug(Response);
    } catch (err) {
      return err;
    }
  } else {
    return console.debug('Redux Actions->updateUsername: no current user');
  }
};

export const resetPassword = () => async (dispatch, getState) => {
  dispatch({
    type: PASSWORD_RESET_EMAIL_SENT,
    pending: true,
  });
  if (firebase.auth().currentUser) {
    const auth = firebase.auth();

    try {
      const response = auth.sendPasswordResetEmail(getState().auth.userProfile.email);

      dispatch({
        type: PASSWORD_RESET_EMAIL_SENT,
        payload: response,
        success: true,
        error: null,
        pending: true,
      });
    } catch (err) {
      console.debug(err);
      dispatch({
        type: PASSWORD_RESET_EMAIL_SENT,
        payload: err,
        success: false,
        error: true,
        pending: false,
      });
    }
  } else {
    return console.debug('Redux Actions->resetPassword: no current user');
  }
};

export const sendEmailChangeEmail = () => async (dispatch, getState) => {
  dispatch({
    type: CHANGE_LOGIN_EMAIL_SENT,
    pending: true,
  });
  if (firebase.auth().currentUser) {
    const auth = firebase.auth();
    const actionCodeSettings = {
      url: 'https://advanced-search--cue-by-coolhand.netlify.com/verify',
      // This must be true.
      handleCodeInApp: true,
    };
    const email = getState().auth.userProfile.email;

    try {
      const response = auth.sendSignInLinkToEmail(email, actionCodeSettings);
      window.localStorage.setItem('emailForSignIn', email);

      dispatch({
        type: CHANGE_LOGIN_EMAIL_SENT,
        payload: response,
        success: true,
        error: null,
        pending: true,
      });
    } catch (err) {
      console.debug(err);
      dispatch({
        type: CHANGE_LOGIN_EMAIL_SENT,
        payload: err,
        success: false,
        error: true,
        pending: false,
      });
    }
  } else {
    return console.debug('Redux Actions->sendEmailChangeEmail: no current user');
  }
};

export const verifySignInThenChangeEmail = () => async (dispatch, getState) => {
  const auth = firebase.auth();
  const {
    newEmail
  } = getState().auth;
  if (auth.isSignInWithEmailLink(window.location.href)) {
    dispatch({
      type: UPDATE_USER_EMAIL,
      pending: true,
    });
    let oldEmail = window.localStorage.getItem('emailForSignIn');
    if (!oldEmail) {
      oldEmail = getState().auth.oldEmail;
    }
    try {
      await auth.signInWithEmailLink(oldEmail, window.location.href);

      window.localStorage.removeItem('emailForSignIn');
      const updateEmailResponse = await auth.currentUser.updateEmail(newEmail);

      // Now we'll update the e-mail in firestore
      const firestore = firebase.firestore();
      const settings = {
        timestampsInSnapshots: true
      };
      firestore.settings(settings);

      const docRef = firestore.doc(`profile/${getState().auth.userInfo.user.uid}`);

      await docRef.set({
        email: newEmail,
      }, {
        merge: true
      });
      dispatch({
        type: UPDATE_USER_EMAIL,
        payload: updateEmailResponse,
        success: true,
        error: false,
        pending: true,
      });
    } catch (err) {
      console.debug(err);

      dispatch({
        type: UPDATE_USER_EMAIL,
        payload: err,
        success: false,
        error: true,
        pending: false,
      });
    }
  } else {
    console.debug('Redux Actions->verifySignInThenChangeEmail: nothing happened');
  }
};

export const setPlayingTrack = songId => ({
  type: SET_PLAYING_TRACK,
  payload: songId
});

export const clearAdvancedTrackData = () => ({
  type: CLEAR_ADVANCED_TRACK_DATA
});

export const setAdvancedTrackData = data => ({
  type: ADVANCED_TRACK,
  payload: data
});

export const resetAuthFields = () => ({
  type: RESET_AUTH_FIELDS
})

export const modalOpen = (bool) => (dispatch) => {
  console.debug("Redux Actions->modalOpen: Should open modal", bool);
  dispatch({
    type: MODAL_IS_OPEN,
    payload: bool
  })
}

export const resetAudioState = params => async (dispatch, getState) => {
  console.debug("Redux Actions->resetAudioState: Resetting audio state");
  const newBody = {
    playPause: 'pause',
    componentPlaying: '',
    isPlaying: false,
    showFooterPlayer: params.showFooterPlayer || false,
    currentIcon: getState().music.audioPlayerState.playIcon,
  };
  dispatch({
    type: UPDATE_AUDIO_STATE,
    payload: newBody,
  });
};

export const clearAudioState = params => async (dispatch, getState) => {
  console.debug("Redux Actions->resetAudioState: Resetting audio state");
  const newBody = {
    trackID: '',
    playPause: 'pause',
    isPlaying: false,
    showFooterPlayer: false,
    songSrc: '',
    componentPlaying: '',
    item: '',
    currentIcon: getState().music.audioPlayerState.playIcon,
  };
  dispatch({
    type: UPDATE_AUDIO_STATE,
    payload: newBody,
  });
};

export const updateAudioState = settings => (dispatch, getState) => {
  console.trace();
  const newBody = settings;
  console.debug("Redux Actions->updateAudioState: Updating audio state", newBody, settings);
  dispatch({
    type: UPDATE_AUDIO_STATE,
    payload: newBody,
  });
  return Promise.resolve(true);
};

export const pauseAudioState = params => (dispatch, getState) => {
  console.debug("Redux Actions->pauseAudio");
  dispatch(updateAudioState({
    currentIcon: getState().music.audioPlayerState.playIcon,
    playIconLeft: '1rem',
    isPlaying: false
  }));
  dispatch({
    type: FOOTER_IS_PAUSED,
    payload: true
  });
}

export const resumeAudioState = params => (dispatch, getState) => {
  console.debug("Redux Actions->resumeAudio", params);
  dispatch(updateAudioState({
    playPauseIcon: getState().music.audioPlayerState.pauseIcon,
    playIconLeft: '1rem',
    isPlaying: true
  }));
  dispatch({
    type: FOOTER_IS_PAUSED,
    payload: false
  });
}

export const pausePlayAudioState = params => dispatch => {
  console.log("Redux Actions->pausePlayAudioState", params);
  if (params.paused === false) {
    dispatch(playAudioState(params));
  } else {
    console.log(params, params.paused, params.paused === true);
    dispatch(pauseAudioState(params));
  }
}

export const playAudioState = params => (dispatch, getState) => {
  console.debug("Redux Actions->playAudio: Playing song", params);
  dispatch(updateAudioState({
    showFooterPlayer: true,
    isPlaying: true,
    currentIcon: getState().music.audioPlayerState.pauseIcon,
    playIconLeft: '1',
    firstAutoPlay: false,
    songProgress: Math.floor((params.currentTime / params.duration) * 100)
  }));
  dispatch({
    type: FOOTER_IS_PAUSED,
    payload: false
  });
};

export const updateAudioProgressUntilDone = params => (dispatch, getState) => {
  let audioPlayerState = getState().music.audioPlayerState,
    extraState = {};

  audioPlayerState = {
    ...audioPlayerState,
    ...(params.state || {}),
    extraState
  };

  console.debug("Redux Actions->updateAudioProgressUntilDone: Updating song progress", audioPlayerState.songProgress);
  dispatch({
    type: UPDATE_AUDIO_STATE,
    payload: audioPlayerState
  });
}

export const searchPerformed = (bool) => async (dispatch) => {
  dispatch({
    type: SEARCH_PERFORMED,
    payload: bool
  })
}

// TOGGLE TO SHOW ADVANCED DATA SUCH AS CUE SCORE AND LYRIC SCORE
export const showAdvancedData = (bool) => async (dispatch) => (dispatch({
  type: SHOW_ADVANCED_DATA,
  payload: bool
}))


// WEBPACK FOOTER //
// ./src/store/actions/index.js